import { createAction, handleActions } from 'redux-actions'

const startFetching = createAction('MODULES/TIMESHEETS_DRAWER/START_FETCHING')
const finishFetching = createAction('MODULES/TIMESHEETS_DRAWER/FINISH_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [startFetching]: () => true,
    [finishFetching]: () => false,
  },
  defaultState,
)

export { startFetching, finishFetching, reducer }
